import script from "./SimpleMode.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleMode.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleMode.vue?vue&type=style&index=0&id=fc1a4b9a&scoped=true&lang=css"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc1a4b9a"]])

export default __exports__